/**
 * @generated SignedSource<<857273134efc375bfee32779dbbd4d07>>
 * @relayHash 0cf2289498521d72da58e16e658edd91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 70e4795808ac0d4f83134e8c310d6575e84f5e548a299f0bfb03b131e6699dc8

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type useListSubscriptions_issueDeletedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type useListSubscriptions_issueDeletedSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useListSubscriptions_issueDeletedSubscription = {
  response: useListSubscriptions_issueDeletedSubscription$data;
  variables: useListSubscriptions_issueDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useListSubscriptions_issueDeletedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useListSubscriptions_issueDeletedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "70e4795808ac0d4f83134e8c310d6575e84f5e548a299f0bfb03b131e6699dc8",
    "metadata": {},
    "name": "useListSubscriptions_issueDeletedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "e885b6209a4f84743ea2296af6385e22";

export default node;
